import { createSelector } from '@reduxjs/toolkit';
import { Document, RootState } from '@greenkub-fronts/shared/interface';

const EMPTY_DOCUMENTS: Document[] = [];

const selectDocumentsQuery = (rootState: RootState, projectId: string) =>
  rootState.api.queries[
    `getDocumentsByProject({"groupName":"ProjectDocumentPage","projectId":${projectId}})`
  ];

const selectDocumentsData = createSelector(
  [selectDocumentsQuery],
  (query) => {
    if (query && query.status === 'fulfilled' && Array.isArray(query.data)) {
      return query.data;
    }

    return EMPTY_DOCUMENTS;
  }
);

const selectSearchValue = (rootState: RootState) =>
  rootState.documentSpace.searchValue;

export const getDocuments: (rootState: RootState, projectId: string) => Document[] = createSelector(
  [selectDocumentsData, selectSearchValue],
  (documents, searchValue) => {
    if (!searchValue) {
      return documents;
    }

    const searchTokens = searchValue.toLocaleLowerCase().split(' ');

    return documents.filter((doc: Document) =>
      searchTokens.every(
        (currentString: string) =>
          doc.originalName.toLowerCase().indexOf(currentString) !== -1
      )
    );
  }
);
